import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import putContato from "../queries/putContato";
import { ContatoTypes } from "../types";

export default function usePutContato(onSuccessEditContato: () => void) {
  return useMutation(
    ({
      contatoAtual,
      id,
      data,
    }: {
      contatoAtual: ContatoTypes;
      id: number;
      data: ContatoTypes;
    }) => {
      //@ts-ignore
      Object.keys(data as any).forEach((key: string) => data[key] === undefined && delete data[key]);

      Object.assign(contatoAtual, data);

      return putContato(id, contatoAtual, () => onSuccessEditContato());
    },
    {
      onSuccess(_, { id }) {
        queryClient.invalidateQueries();
      },
    }
  );
}
